"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _togaIcon = _interopRequireWildcard(require("@thinkific/toga-icon"));

var _togaTypography = require("@thinkific/toga-typography");

var _EmptyState = _interopRequireDefault(require("./EmptyState.css"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_EmptyState["default"]);

var EmptyState = function EmptyState(_ref) {
  var actions = _ref.actions,
      className = _ref.className,
      description = _ref.description,
      hasSurface = _ref.hasSurface,
      icon = _ref.icon,
      isDark = _ref.isDark,
      referenceLink = _ref.referenceLink,
      referenceLinkLabel = _ref.referenceLinkLabel,
      style = _ref.style,
      title = _ref.title,
      titleClass = _ref.titleClass,
      iconClass = _ref.iconClass,
      descriptionClass = _ref.descriptionClass;
  var emptyStateClassNames = cx('empty-state', {
    'empty-state--card': hasSurface,
    'empty-state--dark': isDark
  }, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: emptyStateClassNames,
    style: style
  }, icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('empty-state__icon-container', iconClass)
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: icon,
    "aria-hidden": true
  })), title && /*#__PURE__*/_react["default"].createElement(_togaTypography.H2, {
    className: cx('empty-state__title', titleClass)
  }, title), description && /*#__PURE__*/_react["default"].createElement(_togaTypography.P, {
    className: cx('empty-state__description', descriptionClass)
  }, description), actions && /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('empty-state__actions')
  }, actions), referenceLink && /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('empty-state__reference-link')
  }, /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
    appearance: "link",
    href: referenceLink,
    isDark: isDark,
    target: "_blank"
  }, referenceLinkLabel), /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    className: cx('reference-icon'),
    name: "arrow-up-right",
    "aria-hidden": true
  })));
};

EmptyState.propTypes = {
  /** Array of Buttons or Button */
  actions: _propTypes["default"].oneOf([_propTypes["default"].arrayOf(_propTypes["default"].instanceOf(_togaButton["default"])), _propTypes["default"].instanceOf(_togaButton["default"])]),

  /** Enables attaching classes to the component */
  className: _propTypes["default"].string,

  /** Description of the empty state (will be rendered in a paragraph) */
  description: _propTypes["default"].string,

  /** Enables attaching classes to the description */
  descriptionClass: _propTypes["default"].string,

  /** Show the component in a surface-like block */
  hasSurface: _propTypes["default"].bool,

  /** Icon */
  icon: _propTypes["default"].oneOf(_togaIcon.availableIcons),

  /** Enables attaching classes to the icon */
  iconClass: _propTypes["default"].string,

  /** Uses the dark colour variation */
  isDark: _propTypes["default"].bool,

  /** Reference link rendered at the footer of the component - Use for Help links */
  referenceLink: _propTypes["default"].string,

  /** The label for the referenceLink */
  referenceLinkLabel: _propTypes["default"].string,

  /** Style object - no one possibly needs this */
  style: _propTypes["default"].object,

  /** Empty State title */
  title: _propTypes["default"].string,

  /** Enables attaching classes to the title */
  titleClass: _propTypes["default"].string
};
EmptyState.defaultProps = {
  actions: null,
  className: null,
  description: null,
  hasSurface: false,
  icon: null,
  referenceLink: null,
  referenceLinkLabel: 'Learn more',
  style: {},
  title: null,
  titleClass: null,
  iconClass: null,
  isDark: false,
  descriptionClass: null
};
var _default = EmptyState;
exports["default"] = _default;